const colors = require('tailwindcss/colors')

module.exports = {
  // mode: 'jit',
  purge: ['./public/**/*.html', './src/**/*.{js,jsx,ts,tsx,vue}'],
  darkMode: false,
  theme: {
    fontFamily: {
      display: ['"EB Garamond"', 'serif'],
      body: ['"Nunito Sans"', 'sans-serif'],
    },
    extend: {
      height: {
        128: '32rem',
        256: '64rem',
      },
      maxHeight: {
        128: '32rem',
      },
      colors: {
        primary: {
          100: '#F0F7EB',
          150: '#E8F3E0',
          200: '#DAEBCD',
          300: '#C4DFAE',
          400: '#98C872',
          500: '#6CB035',
          600: '#579427',
          700: '#508227',
          800: '#314F18',
          900: '#203510',
        },
        secondary: {
          100: '#E8F3F9',
          150: '#D8E9F2',
          200: '#B0D6EC',
          300: '#86BFDF',
          400: '#5FABD6',
          500: '#1D99E1',
          600: '#1987C2',
          700: '#187BB4',
          750: '#1771A6',
          800: '#156899',
          900: '#08293B',
        },
        light: {
          100: '#fcfcfc',
          200: '#fafafa',
          300: '#f7f7f7',
          400: '#f5f5f5',
          500: '#f2f2f2',
          600: '#f0f0f0',
          700: '#ededed',
          800: '#ebebeb',
          900: '#e8e8e8',
        },
        orange: colors.orange,
      },
    },
  },
  plugins: [
    require('@tailwindcss/forms'),
    require('@tailwindcss/typography'),
    require('@tailwindcss/aspect-ratio'),
  ],
}
